import { jsx as _jsx } from "react/jsx-runtime";
import { Col as BootstrapCol } from 'react-bootstrap';
import styles from './Col.module.scss';
const Col = ({ xs, sm, md, lg, xl, xxl, className = '', children }) => {
    return (_jsx(BootstrapCol, { xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl, className: `${styles.col} ${className}`, children: children }));
};
export default Col;
